import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getLanguageInformationRes } from "core/http/service/personnelInformation/resTypes";
import { uniqueId } from "lodash";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: getLanguageInformationRes[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [
    {
      foreignLanguageName: "",
      degreeLevelName: "",
      transOrganizationName: "",
    },
  ],
};

const getLanguageInformationSlice = createSlice({
  name: "getLanguageInformation",
  initialState,
  reducers: {
    getLanguageInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getLanguageInformationSuccess: (
      state,
      action: PayloadAction<getLanguageInformationRes[]>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      const degrees = action.payload.map((item) => ({
        ...item,
        files: (item.files ?? []).map((file) => ({
          ...file,
          id: uniqueId(),
        })),
      }));
      state.data = degrees;
    },
    getLanguageInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetLanguageInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  getLanguageInformationStart,
  getLanguageInformationSuccess,
  getLanguageInformationFailed,
  resetLanguageInformation,
} = getLanguageInformationSlice.actions;

export default getLanguageInformationSlice.reducer;
